import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-child-top-menu',
  templateUrl: './child-top-menu.component.html',
  styleUrls: ['./child-top-menu.component.scss']
})
export class ChildTopMenuComponent {

  @Input() title = 'عنوان';
  @Input() returnPath = '';
  @Input() queryParams = {};
  @Output() handleBack = new EventEmitter();
  @Input() appVersion;
  constructor(private router: Router) { }
  returnCondition() {
    if (this.returnPath) {
      this.router.navigate([this.returnPath], { queryParams: this.queryParams });
    } else {
      this.handleBack.emit();
    }
  }
}
